import { http } from "@canvas/api";

export interface GetCmsProductSearchReq {
  endpoint: "cms.api.es.products";
  query: string;
}

export interface GetCmsProductSearchRes {}

export function get(
  req: GetCmsProductSearchReq
): Promise<GetCmsProductSearchRes> {
  //@self doing this for this api as without this the result is not correct and also doing encodeURIComponent is yeilding wrong result
  const query = req.query.replace(/;/g, "%3B");
  return http
    .GET(`/cms/api/es/products?${query}`)
    .then((response: GetCmsProductSearchRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
